export class SyncfusionGridHelper {

    public static isFilterAction(args: any): boolean {
        return args?.requestType === 'filtering'
            || args?.requestType === 'clearFiltering'
            || args?.action === 'filter'
            || args?.action === 'clear-filter';
    }

    public static parseDatePickerValue = (value: any): Date | null => {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            return value;
        }

        // Verwacht bijvoorbeeld: "11-06-2026" of "11-06-2026 00:00"
        const datePart = value.toString().split(' ')[0];
        const parts = datePart.split('-');

        if (parts.length !== 3) {
            return null;
        }

        const day = Number(parts[0]);
        const month = Number(parts[1]);
        const year = Number(parts[2]);

        if (!day || !month || !year) {
            return null;
        }

        return new Date(year, month - 1, day);
    };
}


